import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GlobalContextProvider } from './GlobalContext';

// Test webhookgetPurchasOrderHistoryHeader2

// Pages
import Login from "./pages/Login";
import SelectCompany from "./pages/SelectCompany";
import Dashboard from "./pages/Dashboard";
// Warehouse
import Picking from "./pages/Picking";
import PickingSOList from "./pages/PickingSalesOrderList";
// Sale orders
import SalesOrdersNew from "./pages/SalesOrdersNew";

const App = () => {
  return (
    <GlobalContextProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/select-company" element={<SelectCompany />} />
          <Route path="/dashboard/:id" element={<Dashboard />} />
          <Route path="/warehouse/:id/picking-system" element={<Picking />} />
          <Route path="/warehouse/:id/sales-order-list" element={<PickingSOList />} />
          <Route path="/sales-orders/:id/new" element={<SalesOrdersNew />} />
        </Routes>
      </Router>
    </GlobalContextProvider>
  );
};

export default App;
